// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../common/images/appointment.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs-table {
  width: 90%;
  margin: auto;
}
.done-button {
  margin: 10px;
}
.treated {
  background-color: #40c51f;
  color: #fff;
  text-align: center;
}
.slot-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.btn-previous {
  margin-right: 10px;
}
.parent-step {
  width: 100%;
  margin: auto;
  margin-bottom: 50px;
}
.tabs-table {
  width: 90%;
  margin: auto;
}
.appoinment-type-container,
.final-info-container {
  width: 100%;
  margin: auto;
}
@keyframes shake {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-10px);
  }
  50% {
    transform: translateX(0);
  }
  75% {
    transform: translateX(10px);
  }
  100% {
    transform: translateX(0);
  }
}
.days-tag {
  padding: 10px 10px;
  color: black;
  margin-left: 12px;
  font-family: Arial, Helvetica, sans-serif;
  text-align: center;
  font-weight: 400;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0);
  font-size: 14px;
}
.slot-button:hover {
  color: black !important;
}
.timeslot-container ::before {
  background-color: snow !important;
}
.timeslot-container .slot-button {
  background-color: #66d34b !important;
  border: 1px solid #66d34b !important;
  width: 140px !important;
  text-align: center;
  color: black;
  font-weight: 400 !important;
  border-radius: 4px !important;
  font-size: 11px !important;
  margin: 4px !important;
}
.timeslot-container .slot-button.selected {
  color: white !important;
  border: 1px solid #2196f3 !important;
  background-color: #2196f3 !important;
}
.timeslot-container .slot-button.disabled {
  color: white !important;
  border: 1px solid #b71c1c !important;
  background-color: #b71c1c !important;
}
.slot-scroll {
  height: 180px !important;
  overflow: scroll;
}
.calender-title {
  font-weight: 500;
  font-size: medium;
}
.avatarimage {
  width: 9% !important;
}
.cardfont {
  color: #4dd5e7;
  padding: 1%;
}
.ant-table .ant-table-container .ant-table-content table thead.ant-table-thead {
  background-color: #2196f3 !important;
}
.ant-table-thead .ant-table-cell {
  color: antiquewhite !important;
}
.patient-email {
  font-size: large;
  text-transform: uppercase;
}
.patient-history-header {
  height: 10%;
}
.appoinment-card {
  margin: 32px 5rem 8px 0 !important;
  width: 380px !important;
}
.app-with-card {
  display: flex;
  justify-content: end;
  align-items: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: #cde9ed;
  background-position: left;
  background-repeat: no-repeat;
  background-origin: content-box;
  background-size: cover;
  margin: -32px -32px !important;
}
.app-with-card-success {
  padding: 0px 0 2rem !important;
  height: auto;
}
.app-with-card-failure {
  height: 106%;
}
@media only screen and (max-width: 425px) and (min-width: 320px) {
  .appoinment-status-select {
    margin-left: 0% !important;
  }
  .container {
    position: relative;
    width: 100% !important;
  }
  .btn {
    width: 300px !important;
  }
  .video2 {
    height: 150px !important;
    width: 150px !important;
    position: absolute;
    right: 0 !important;
    bottom: 0 !important;
  }
  .screenvideo {
    width: 200px !important;
    height: 200px !important;
  }
  .screen2 {
    height: 150px !important;
    width: 150px !important;
    left: 200px !important;
  }
  .display-time {
    left: 10% !important;
  }
  .video2-mute {
    left: 210px !important;
    bottom: 250px !important;
  }
}
@media only screen and (max-width: 563px) {
  .app-with-card {
    justify-content: center;
  }
  .appoinment-card {
    margin: 1rem auto !important;
    width: 300px !important;
  }
}
@media only screen and (max-width: 768px) and (min-width: 563px) {
  .btn {
    position: absolute;
    width: 300px;
    margin-left: 10% !important;
    padding: 10px !important;
  }
  .screenvideo {
    width: 500px !important;
    height: 400px !important;
  }
  .screen2 {
    height: 200px !important;
    width: 200px !important;
    position: absolute;
    bottom: 250px;
    left: 100px !important;
  }
  .big-button {
    width: 100% !important;
  }
  .full-screen-time {
    bottom: 350px !important;
    left: 200px !important;
  }
  .appoinment-card {
    margin: 32px 1rem 8px 0 !important;
    width: 380px !important;
  }
}
@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .appoinment-card {
    margin: 32px 5rem 8px 0 !important;
    width: 380px !important;
  }
  .appoinment-status-select {
    padding-left: 2% !important;
    width: 98%;
  }
  .controls {
    top: 90% !important;
  }
  .container {
    left: 0% !important;
  }
  .big-button {
    width: 80% !important;
  }
  .screen2 {
    left: 200% !important;
  }
  .app-with-card {
    background-size: 100% 100%;
  }
}
@media only screen and (max-width: 1440px) and (min-width: 1024px) {
  .appoinment-card {
    margin: 32px 5rem 8px 0 !important;
    width: 400px !important;
  }
  .app-with-card {
    padding-right: auto !important;
  }
  .appoinment-status-select {
    padding-left: 10%;
    width: 98%;
  }
  .btn {
    left: 5% !important;
  }
  .screen2 {
    height: 200px !important;
    width: 200px !important;
    left: 400px !important;
  }
}
@media only screen and (max-width: 2560px) and (min-width: 1500px) {
  .appoinment-status-select {
    padding-left: 18%;
    width: 97%;
  }
  .container {
    left: 50% !important;
  }
  .btn {
    left: 100% !important;
  }
  .screen2 {
    height: 200px !important;
    width: 200px !important;
    position: absolute;
    bottom: 250px;
    left: 800px !important;
  }
  .screenvideo {
    width: 1500px !important;
    height: 450px !important;
  }
  .appoinment-card {
    margin: 32px 10rem 8px 0 !important;
    width: 380px !important;
  }
}
.d-none {
  display: none !important;
}
.Video1 {
  height: 100%;
  width: 100%;
  margin: 0 !important;
  object-fit: cover;
  position: relative;
}
.video2 {
  z-index: 5;
  height: 200px;
  width: 150px;
  position: absolute;
  bottom: 0;
  right: 0;
  object-fit: cover;
}
.agora_video_player {
  object-fit: contain !important;
}
.video2-mute {
  position: absolute;
  bottom: 180px;
  left: 430px;
  background-color: #2196f3;
  border-color: #2196f3;
  color: white;
}
#first {
  height: 100%;
  position: relative;
  border-radius: 5%;
}
#first #second {
  width: 80%;
  position: absolute;
  top: 90%;
  left: 75% !important;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: space-between;
}
.container {
  top: 0px !important;
  left: 0% !important;
  text-align: center;
  border: none;
}
.btn {
  position: absolute;
  display: flex;
  justify-content: space-between;
  left: 20% !important;
  top: 85%;
  border: none;
  left: 25% !important;
}
.big-button {
  position: absolute;
  display: flex;
  justify-content: space-around;
  left: 40% !important;
  top: 85%;
  border: none;
}
.video-btn {
  border: none;
  background-color: rgba(200, 200, 200, 0.4) !important;
  color: white !important;
}
.video-btn svg {
  width: 20px !important;
  height: 20px !important;
  text-align: center !important;
  margin-top: 7px;
}
.video-btn svg path {
  fill: white !important;
}
.video-leave {
  background-color: #f7635b !important;
  border: none;
  border-radius: 35% !important;
}
.video-leave svg path {
  fill: white !important;
  color: white !important;
}
.video-leave svg {
  width: 50% !important;
  height: 35% !important;
  margin-top: 25% !important;
  -webkit-transform: rotate(135deg);
  -moz-transform: rotate(135deg);
  -ms-transform: rotate(135deg);
  -o-transform: rotate(135deg);
  transform: rotate(135deg);
}
.mute {
  background-color: #003366 !important;
  border-color: #003366 !important;
}
.mute svg {
  width: 20px !important;
  height: 20px !important;
  text-align: center !important;
  margin-top: 7px;
}
.mute svg path {
  fill: white !important;
}
.screenvideo {
  width: 700px !important;
  height: 450px !important;
}
.screen2 {
  height: 200px !important;
  width: 150px !important;
  position: absolute;
  bottom: 220px;
  left: 500px !important;
}
.display-time {
  position: absolute;
  bottom: 350px;
  left: 100% !important;
  color: antiquewhite;
}
.full-screen-time {
  position: absolute;
  top: 0;
  left: 5px !important;
  color: antiquewhite;
}
.remarks {
  margin-left: 3%;
  width: 95%;
}
.remove-button {
  display: flex;
  justify-content: center;
  align-items: center;
}
.minu-font-size {
  font-size: 25px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/modules/appoinment.less"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,oCAAoC;AACtC;AACA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,oCAAoC;AACtC;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,yDAA4D;EAC5D,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,2BAA2B;IAC3B,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,sBAAsB;EACxB;EACA;IACE,kCAAkC;IAClC,uBAAuB;EACzB;AACF;AACA;EACE;IACE,kCAAkC;IAClC,uBAAuB;EACzB;EACA;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,kCAAkC;IAClC,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;EACA;IACE,mCAAmC;IACnC,uBAAuB;EACzB;AACF;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,YAAY;AACd;AACA;EACE,YAAY;EACZ,qDAAqD;EACrD,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB","sourcesContent":[".tabs-table {\n  width: 90%;\n  margin: auto;\n}\n.done-button {\n  margin: 10px;\n}\n.treated {\n  background-color: #40c51f;\n  color: #fff;\n  text-align: center;\n}\n.slot-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.btn-previous {\n  margin-right: 10px;\n}\n.parent-step {\n  width: 100%;\n  margin: auto;\n  margin-bottom: 50px;\n}\n.tabs-table {\n  width: 90%;\n  margin: auto;\n}\n.appoinment-type-container,\n.final-info-container {\n  width: 100%;\n  margin: auto;\n}\n@keyframes shake {\n  0% {\n    transform: translateX(0);\n  }\n  25% {\n    transform: translateX(-10px);\n  }\n  50% {\n    transform: translateX(0);\n  }\n  75% {\n    transform: translateX(10px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n.days-tag {\n  padding: 10px 10px;\n  color: black;\n  margin-left: 12px;\n  font-family: Arial, Helvetica, sans-serif;\n  text-align: center;\n  font-weight: 400;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 0, 0, 0);\n  font-size: 14px;\n}\n.slot-button:hover {\n  color: black !important;\n}\n.timeslot-container ::before {\n  background-color: snow !important;\n}\n.timeslot-container .slot-button {\n  background-color: #66d34b !important;\n  border: 1px solid #66d34b !important;\n  width: 140px !important;\n  text-align: center;\n  color: black;\n  font-weight: 400 !important;\n  border-radius: 4px !important;\n  font-size: 11px !important;\n  margin: 4px !important;\n}\n.timeslot-container .slot-button.selected {\n  color: white !important;\n  border: 1px solid #2196f3 !important;\n  background-color: #2196f3 !important;\n}\n.timeslot-container .slot-button.disabled {\n  color: white !important;\n  border: 1px solid #b71c1c !important;\n  background-color: #b71c1c !important;\n}\n.slot-scroll {\n  height: 180px !important;\n  overflow: scroll;\n}\n.calender-title {\n  font-weight: 500;\n  font-size: medium;\n}\n.avatarimage {\n  width: 9% !important;\n}\n.cardfont {\n  color: #4dd5e7;\n  padding: 1%;\n}\n.ant-table .ant-table-container .ant-table-content table thead.ant-table-thead {\n  background-color: #2196f3 !important;\n}\n.ant-table-thead .ant-table-cell {\n  color: antiquewhite !important;\n}\n.patient-email {\n  font-size: large;\n  text-transform: uppercase;\n}\n.patient-history-header {\n  height: 10%;\n}\n.appoinment-card {\n  margin: 32px 5rem 8px 0 !important;\n  width: 380px !important;\n}\n.app-with-card {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  background-image: url(\"../../common/images/appointment.jpg\");\n  background-color: #cde9ed;\n  background-position: left;\n  background-repeat: no-repeat;\n  background-origin: content-box;\n  background-size: cover;\n  margin: -32px -32px !important;\n}\n.app-with-card-success {\n  padding: 0px 0 2rem !important;\n  height: auto;\n}\n.app-with-card-failure {\n  height: 106%;\n}\n@media only screen and (max-width: 425px) and (min-width: 320px) {\n  .appoinment-status-select {\n    margin-left: 0% !important;\n  }\n  .container {\n    position: relative;\n    width: 100% !important;\n  }\n  .btn {\n    width: 300px !important;\n  }\n  .video2 {\n    height: 150px !important;\n    width: 150px !important;\n    position: absolute;\n    right: 0 !important;\n    bottom: 0 !important;\n  }\n  .screenvideo {\n    width: 200px !important;\n    height: 200px !important;\n  }\n  .screen2 {\n    height: 150px !important;\n    width: 150px !important;\n    left: 200px !important;\n  }\n  .display-time {\n    left: 10% !important;\n  }\n  .video2-mute {\n    left: 210px !important;\n    bottom: 250px !important;\n  }\n}\n@media only screen and (max-width: 563px) {\n  .app-with-card {\n    justify-content: center;\n  }\n  .appoinment-card {\n    margin: 1rem auto !important;\n    width: 300px !important;\n  }\n}\n@media only screen and (max-width: 768px) and (min-width: 563px) {\n  .btn {\n    position: absolute;\n    width: 300px;\n    margin-left: 10% !important;\n    padding: 10px !important;\n  }\n  .screenvideo {\n    width: 500px !important;\n    height: 400px !important;\n  }\n  .screen2 {\n    height: 200px !important;\n    width: 200px !important;\n    position: absolute;\n    bottom: 250px;\n    left: 100px !important;\n  }\n  .big-button {\n    width: 100% !important;\n  }\n  .full-screen-time {\n    bottom: 350px !important;\n    left: 200px !important;\n  }\n  .appoinment-card {\n    margin: 32px 1rem 8px 0 !important;\n    width: 380px !important;\n  }\n}\n@media only screen and (max-width: 1024px) and (min-width: 768px) {\n  .appoinment-card {\n    margin: 32px 5rem 8px 0 !important;\n    width: 380px !important;\n  }\n  .appoinment-status-select {\n    padding-left: 2% !important;\n    width: 98%;\n  }\n  .controls {\n    top: 90% !important;\n  }\n  .container {\n    left: 0% !important;\n  }\n  .big-button {\n    width: 80% !important;\n  }\n  .screen2 {\n    left: 200% !important;\n  }\n  .app-with-card {\n    background-size: 100% 100%;\n  }\n}\n@media only screen and (max-width: 1440px) and (min-width: 1024px) {\n  .appoinment-card {\n    margin: 32px 5rem 8px 0 !important;\n    width: 400px !important;\n  }\n  .app-with-card {\n    padding-right: auto !important;\n  }\n  .appoinment-status-select {\n    padding-left: 10%;\n    width: 98%;\n  }\n  .btn {\n    left: 5% !important;\n  }\n  .screen2 {\n    height: 200px !important;\n    width: 200px !important;\n    left: 400px !important;\n  }\n}\n@media only screen and (max-width: 2560px) and (min-width: 1500px) {\n  .appoinment-status-select {\n    padding-left: 18%;\n    width: 97%;\n  }\n  .container {\n    left: 50% !important;\n  }\n  .btn {\n    left: 100% !important;\n  }\n  .screen2 {\n    height: 200px !important;\n    width: 200px !important;\n    position: absolute;\n    bottom: 250px;\n    left: 800px !important;\n  }\n  .screenvideo {\n    width: 1500px !important;\n    height: 450px !important;\n  }\n  .appoinment-card {\n    margin: 32px 10rem 8px 0 !important;\n    width: 380px !important;\n  }\n}\n.d-none {\n  display: none !important;\n}\n.Video1 {\n  height: 100%;\n  width: 100%;\n  margin: 0 !important;\n  object-fit: cover;\n  position: relative;\n}\n.video2 {\n  z-index: 5;\n  height: 200px;\n  width: 150px;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  object-fit: cover;\n}\n.agora_video_player {\n  object-fit: contain !important;\n}\n.video2-mute {\n  position: absolute;\n  bottom: 180px;\n  left: 430px;\n  background-color: #2196f3;\n  border-color: #2196f3;\n  color: white;\n}\n#first {\n  height: 100%;\n  position: relative;\n  border-radius: 5%;\n}\n#first #second {\n  width: 80%;\n  position: absolute;\n  top: 90%;\n  left: 75% !important;\n  transform: translate(-50%, -50%);\n  display: flex;\n  justify-content: space-between;\n}\n.container {\n  top: 0px !important;\n  left: 0% !important;\n  text-align: center;\n  border: none;\n}\n.btn {\n  position: absolute;\n  display: flex;\n  justify-content: space-between;\n  left: 20% !important;\n  top: 85%;\n  border: none;\n  left: 25% !important;\n}\n.big-button {\n  position: absolute;\n  display: flex;\n  justify-content: space-around;\n  left: 40% !important;\n  top: 85%;\n  border: none;\n}\n.video-btn {\n  border: none;\n  background-color: rgba(200, 200, 200, 0.4) !important;\n  color: white !important;\n}\n.video-btn svg {\n  width: 20px !important;\n  height: 20px !important;\n  text-align: center !important;\n  margin-top: 7px;\n}\n.video-btn svg path {\n  fill: white !important;\n}\n.video-leave {\n  background-color: #f7635b !important;\n  border: none;\n  border-radius: 35% !important;\n}\n.video-leave svg path {\n  fill: white !important;\n  color: white !important;\n}\n.video-leave svg {\n  width: 50% !important;\n  height: 35% !important;\n  margin-top: 25% !important;\n  -webkit-transform: rotate(135deg);\n  -moz-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  -o-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n.mute {\n  background-color: #003366 !important;\n  border-color: #003366 !important;\n}\n.mute svg {\n  width: 20px !important;\n  height: 20px !important;\n  text-align: center !important;\n  margin-top: 7px;\n}\n.mute svg path {\n  fill: white !important;\n}\n.screenvideo {\n  width: 700px !important;\n  height: 450px !important;\n}\n.screen2 {\n  height: 200px !important;\n  width: 150px !important;\n  position: absolute;\n  bottom: 220px;\n  left: 500px !important;\n}\n.display-time {\n  position: absolute;\n  bottom: 350px;\n  left: 100% !important;\n  color: antiquewhite;\n}\n.full-screen-time {\n  position: absolute;\n  top: 0;\n  left: 5px !important;\n  color: antiquewhite;\n}\n.remarks {\n  margin-left: 3%;\n  width: 95%;\n}\n.remove-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.minu-font-size {\n  font-size: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
